import { isMobile } from '../utils';

export default class Gallery {
	constructor(GalleryGrid) {

		const galleryItems = document.querySelectorAll('[data-gallery-item]');

		this.portfolioSliderIsMobile = document.querySelector('[data-portfolio-slider-sm]');
		this.portfolioSlider = document.querySelector('[data-portfolio-slider]');
		this.galleryIcon = document.querySelector('[data-open-gallery]');

		this.slider = null;

		if(isMobile()) {
			this.slider = this.portfolioSliderIsMobile;
		} else {
			this.slider = this.portfolioSlider;
		}

		this.openGallery();

		galleryItems.forEach(image => {
			image.addEventListener('click', e => {

				this.closeGallery();

				const attr = image.getAttribute('data-gallery-item');
				const slide = this.slider.querySelector(`[data-contains-image-${attr}]`);

				const parent = slide.parentNode;
				const index = Array.prototype.indexOf.call(parent.children, slide);

				this.slider.swiper.slideTo(index, 0);
			});
		});
	}

	openGallery() {
		this.slider.classList.add('is-hidden');
		this.gallery = document.querySelector('[data-portfolio-gallery]');
		this.gallery.classList.toggle('is-open');
		this.modal = document.querySelector('.modal-outer');
		this.modal.classList.add('modal-portfolio-gallery');
	}

	closeGallery() {
		this.slider.classList.remove('is-hidden');
		this.galleryIcon.classList.add('is-active');
		this.gallery.classList.remove('is-open');
		this.modal.classList.remove('modal-portfolio-gallery');
	}
}